import { footerGroups } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className="ri-image-2-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold tracking-wide text-background-50">黑料照片</span>
            </div>
            <p className="text-sm leading-relaxed text-background-300">
              站内汇总热门事件的黑料照片合集与高清原图，按人物、事件分类整理，持续更新最新收录内容，方便快速浏览完整图集。
            </p>
            <div className="flex items-center gap-2 text-xs text-background-300">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-400 animate-soft-pulse"></span>
              收录持续更新中
            </div>
          </div>

          {footerGroups.map((group) => (
            <div key={group.title} className="flex flex-col gap-4">
              <h3 className="font-heading text-sm font-bold uppercase tracking-widest text-accent-400">{group.title}</h3>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-200 transition-colors hover:text-background-50"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-50/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-400">
            © 2026 黑料照片 图集归档站 · 全站内容按人物与事件分类整理
          </p>
          <p className="text-xs text-background-400">
            本站仅作信息归档与索引展示，如对收录内容有异议可通过「内容反馈」联系处理。
          </p>
        </div>
      </div>
    </footer>
  );
}